import React, { useEffect, useState } from 'react';
import { getGroups, createGroup, deleteGroup } from '../services/api';
import './ManageGroups.css';

const ManageGroups = () => {
  const [groups, setGroups] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await getGroups();
      setGroups(resp.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const onCreate = async () => {
    if (!name.trim()) return;
    await createGroup(name.trim(), description.trim());
    setName(''); setDescription('');
    await load();
  };

  const onDelete = async (id) => {
    if (!window.confirm('Excluir este grupo?')) return;
    await deleteGroup(id);
    await load();
  };

  return (
    <div className="container">
      <div className="managegroups-header">
        <h1 className="managegroups-page-title">Grupos</h1>
        <p className="managegroups-page-subtitle">Gerencie grupos e permissões</p>
      </div>

      <div className="managegroups-card" style={{padding:'16px'}}>
        <h3>Novo grupo</h3>
        <div className="managegroups-form-row">
          <input className="managegroups-form-input" placeholder="Nome" value={name} onChange={e=>setName(e.target.value)} />
          <input className="managegroups-form-input" placeholder="Descrição (opcional)" value={description} onChange={e=>setDescription(e.target.value)} />
          <button className="btn btn-primary" onClick={onCreate} disabled={!name.trim()}>Criar</button>
        </div>
      </div>

      <div className="managegroups-card" style={{marginTop:'16px'}}>
        {loading ? <div className="managegroups-loading">Carregando...</div> : (
          <div className="managegroups-table-container">
            <table className="managegroups-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th style={{width:80}}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {(groups || []).map(g => (
                  <tr key={g.id}>
                    <td>{g.id}</td>
                    <td>{g.name}</td>
                    <td>{g.description || '-'}</td>
                    <td>
                      <button className="btn btn-danger" onClick={()=>onDelete(g.id)}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageGroups;


